import type { Translations } from './en.js';

const th: Translations = {
  ok: 'ตกลง',
  cancel: 'ยกเลิก',
  close: 'ปิด',
  confirm: 'ยืนยัน',
  language: 'ภาษา',

  game_title: 'อัปเกรดดาบ',
  tap_to_start: 'แตะเพื่อเริ่ม',
  title_load_failed: 'โหลดรูปชื่อเกมล้มเหลว:',
  game_started: 'เริ่มเกมอัปเกรดดาบ!',

  level_label: 'Lv.{n}',
  gold_suffix: 'G',
  rate_suffix: '%',
  rate_clear: '🎉 ผ่านทั้งหมด!',
  rate_display: '{rate}%',
  rate_display_boosted: '{rate}% ⬆',
  gold_display: '{amount} G',
  gold_display_free: '0 G (ฟรี!)',

  btn_enhance: '⚒️ อัปเกรด',
  btn_enhance_ready: '⚔️ อัปเกรด',
  btn_enhance_complete: '🏆 เสร็จสิ้น',
  btn_free_enhance: '▶ อัปเกรดฟรี',
  btn_exhausted: 'ใช้หมด',
  btn_boost: 'เพิ่ม\nโอกาส',
  btn_applying: 'กำลัง\nใช้!',
  btn_protection_active: '🛡️ ป้องกันใช้งาน',
  btn_protection_use: '🛡️ ใช้ม้วนป้องกัน',
  btn_sell: '💰 ขาย',
  btn_sell_amount: '💰 {amount}G',
  btn_shop: '🏪 ร้านค้า',
  cost_max: 'MAX',
  cost_free: '0 G (ฟรี!)',

  tab_settings: '⚙️ ตั้งค่า',
  tab_inventory: '📦 กระเป๋า',
  bgm_on: '🎵 เพลงเปิด',
  bgm_off: '🎵 เพลงปิด',
  sfx_on: '🔊 เสียงเปิด',
  sfx_off: '🔊 เสียงปิด',
  inventory_title: '⚔️ อาวุธที่เก็บไว้',
  inventory_empty: 'ไม่มีอาวุธเก็บไว้',
  equip: 'สวมใส่',
  equip_msg: 'สวมใส่ {name}!',
  reset_confirm_title: '⚠️ ต้องการรีเซ็ตหรือไม่?',
  reset_confirm_desc: 'ความคืบหน้าทั้งหมดจะถูกลบ',
  reset: 'รีเซ็ต',
  reset_start_over: '🔄 เริ่มใหม่ทั้งหมด',
  menu_close: 'ปิด',

  inv_scrolls_title: '🛡️ ม้วนป้องกันที่มี',
  inv_scrolls_line1: 'ต้น: {c0}  |  กลาง: {c1}',
  inv_scrolls_line2: 'สูง: {c2}  |  พิเศษ: {c3}',
  inv_weapon_entry: '{name} (Lv.{level})',

  ad_gold_title: 'ดูโฆษณาเพื่ออัปเกรดฟรี',
  ad_gold_desc: 'การอัปเกรดครั้งต่อไปฟรี',
  ad_gold_note: '(ม้วนป้องกัน/เพิ่มโอกาสยังทำงาน)',
  ad_gold_confirm: '▶ ดูโฆษณา',
  ad_gold_free_next: 'อัปเกรดครั้งต่อไปฟรี!',
  ad_gold_exhausted: 'จำนวนครั้งหมดแล้ว!',
  ad_gold_remaining: 'คงเหลือ: {current}/3',

  boost_popup_title: '📺 ดูโฆษณา',
  boost_confirm: '▶ ดูโฆษณาเพื่อใช้',
  boost_close: 'ปิด',
  boost_applied: 'เพิ่มโอกาสแล้ว!',
  boost_already_applied: 'กำลังใช้อยู่แล้ว!',
  boost_exhausted: 'จำนวนครั้งหมดแล้ว!',
  boost_remaining: '🎬 เหลือการใช้งาน: {current}/3',
  boost_popup_desc: 'ปัจจุบัน {rate}% → x{mult}',
  boost_rate_display: '{rate}%',
  boost_mult_2x: 'x2',
  boost_mult_1_5x: 'x1.5',
  boost_mult_1_3x: 'x1.3',

  protection_popup_title: '🛡️ ใช้ม้วนป้องกัน',
  protection_use: 'ใช้',
  protection_cancel: 'ยกเลิก',
  protection_popup_info:
    'เลเวลปัจจุบัน: Lv.{level}\nต้องใช้: {name} 1 ชิ้น\nมี: {count} ชิ้น',
  protection_activated: '{name} ทำงานแล้ว!',
  protection_returned: '{name} คืนแล้ว',
  protection_protected: '🛡️ ม้วนป้องกันทำงาน!',

  msg_max_level: 'ถึงระดับสูงสุดแล้ว!',
  msg_gold_short: 'ทองไม่พอ!',
  msg_success_boost: 'อัปเกรดบูสต์สำเร็จ!',
  msg_success: 'อัปเกรดสำเร็จ!',
  msg_destroyed: '💥 ทำลาย!',

  shop_title: 'ร้านค้า',
  tab_protection: 'การป้องกัน',
  tab_weapons: 'ซื้ออาวุธ',
  weapon_shop_title: '⚔️ ซื้ออาวุธ',
  item_free: 'ฟรี',
  close_shop: 'ปิด',
  buy_complete_title: 'ซื้อสำเร็จ!',
  buy_complete_desc: 'ไอเทมที่ซื้อจะอยู่ใน\nตั้งค่า (ด้านบน) → 📦 กระเป๋า',
  buy_complete_ok: 'ตกลง',
  scroll_shop_label: '{name} (Lv.{min}-{max})',
  scroll_purchased: 'ได้ {name} แล้ว!',
  weapon_moved_to_inventory: '{name} → กระเป๋า',
  price_display: '{amount}G',
  sell_received: 'ได้ {amount}G!',

  destroy_title: 'อาวุธถูกทำลาย',
  destroy_ad_restore: '▶ ดูโฆษณาเพื่อกู้คืน',
  destroy_restore_ad: 'ดูโฆษณาเพื่อกู้คืน ({current}/{max})',
  destroy_give_up: 'เริ่มใหม่',
  destroy_restore_count: '🎬 โอกาสกู้คืน: {current}/{max}',
  destroy_restored: 'Lv.{level} weapon restored!',
  ad_watch_fail: 'ดูโฆษณาล้มเหลว',
  weapon_restored: 'กู้คืน {name} สำเร็จ!',

  completion_title: 'คุณสร้างดาบสูงสุดสำเร็จ!',
  completion_all_done: '🏆 อัปเกรดครบทั้งหมด! 🏆',
  congrats_text: '🎉 ยินดีด้วย! 🎉',
  register_name: '✏️ ลงชื่อ',
  prompt_register_name: 'กรอกชื่อเพื่อลงทะเบียนในหอเกียรติยศ:',
  no_completion: 'ยังไม่มีผู้ผ่าน',
  be_first: 'เป็นคนแรกที่ทำได้!',
  completion_close: 'ปิด',
  leaderboard_title: '📋 หอเกียรติยศ',
  leaderboard_entry: 'อันดับ {rank} - {name}',
  completion_rank_msg: 'คุณคือผู้สำเร็จคนที่ {rank}!',
  completion_total_msg: 'มีผู้สำเร็จแล้ว {total} คน',

  weapon_image_load_failed: 'โหลดรูปอาวุธล้มเหลว:',

  weapon_0: 'มือเปล่า',
  weapon_1: 'มีดสั้นธรรมดา',
  weapon_2: 'ดาบเหล็ก',
  weapon_3: 'ดาบเงิน',
  weapon_4: 'ดาบสโนว์บอร์ด',
  weapon_5: 'ดาบคลื่น',
  weapon_6: 'ดาบสาวน้อยเวทมนตร์',
  weapon_7: 'ดาบหมี',
  weapon_8: 'ดาบหัวกะโหลกไฟ',
  weapon_9: 'ดาบสายฟ้า',
  weapon_10: 'มีดสั้นแสงจันทร์',
  weapon_11: 'ดาบมังกร',
  weapon_12: 'ดาบกล้าม',
  weapon_13: 'ดาบราชาเพชร',
  weapon_14: 'ง้าวมังกรฟ้า',
  weapon_15: 'ดาบโบราณ',
  weapon_16: 'ดาบคู่ราชาโจรสลัด',
  weapon_17: 'ดาบเหนียวดูไบ',
  weapon_18: 'ดาบเจ็ดเจ็ด',
  weapon_19: 'ไม้เท้า-ดาบเวทมนตร์',
  weapon_20: 'ดาบหึ่งหึ่ง',
  weapon_21: 'ดาบพาเลท',
  weapon_22: 'ดาบธรรมชาติ',
  weapon_23: 'ดาบไซบอร์ก',
  weapon_24: 'ดาบหลุมดำ',
  weapon_25: 'ดาบนกทอง',
  weapon_26: 'ดาบพลังคริสตัล',
  weapon_27: 'ดาบมังกรดำ',
  weapon_28: 'ดาบก้ามปู',
  weapon_29: 'ดาบ AI',
  weapon_30: 'ดาบเลื่อยยนต์',
  weapon_31: 'ดาบพลังดาวตก',
  weapon_32: 'ดาบมืดมืด',
  weapon_33: 'ดาบกาแล็กซี',
  weapon_34: 'ดาบเพชรแพงสุดยอด',

  scroll_basic: 'ม้วนป้องกันระดับต้น',
  scroll_mid: 'ม้วนป้องกันระดับกลาง',
  scroll_hi: 'ม้วนป้องกันระดับสูง',
  scroll_ultra: 'ม้วนป้องกันระดับพิเศษ',
  scroll_label_basic: 'ต้น',
  scroll_label_mid: 'กลาง',
  scroll_label_hi: 'สูง',
  scroll_label_ultra: 'พิเศษ',

  // === Materials (Sprint 1) ===
  mat_iron_dust: 'ผงเหล็ก',
  mat_refining_core: 'แกนกลั่น',
  mat_lava_essence: 'สาระลาวา',
  mat_abyss_crystal: 'คริสตัลเหว',

  mat_drop_notice: '+{amount} {name}',
  mat_drop_title: 'ได้รับวัสดุ!',
  mat_double_ad: 'ดูโฆษณา x2',
  mat_doubled: 'x2 ใช้งานแล้ว!',
  mat_panel_title: 'วัสดุ',

  // === Keep / Weapon Inventory (Sprint 1) ===
  keep_btn: 'เก็บ',
  keep_full: 'คลังเต็ม!',
  keep_lv1_blocked: 'อาวุธ Lv.1 ไม่สามารถเก็บได้',
  keep_success: 'เก็บ {name} แล้ว!',
  keep_retrieve: 'สวมใส่',
  keep_sell: 'ขาย',
  keep_slot_expand: 'ขยายช่อง',
  keep_slot_cost: '{amount}G',
  keep_slot_max: 'MAX',
  keep_slot_count: 'ช่อง: {used}/{total}',
  keep_panel_title: 'อาวุธที่เก็บ',
  keep_empty: 'ไม่มีอาวุธที่เก็บ',
  keep_weapon_entry: 'Lv.{level} {name}',
  keep_sell_received: '+{amount}G',
  keep_no_slot: 'ขยายช่องเพิ่ม!',

  // === เตาหลอม (Sprint 2) ===
  tab_forge: 'เตาหลอม',
  forge_title: 'เตาหลอม',
  forge_tab_weapon: 'อาวุธ',
  forge_tab_scroll: 'ม้วนคุ้มครอง',
  forge_tab_upgrade: 'อัปเกรดวัสดุ',
  forge_craft_btn: 'สร้าง',
  forge_craft_success: 'สร้าง {name} สำเร็จ!',
  forge_not_enough_mat: 'วัสดุไม่เพียงพอ',
  forge_weapon_to_equip: 'สวมใส่ตอนนี้?',
  forge_weapon_to_keep: 'เก็บ',
  forge_weapon_equip: 'สวมใส่',
  forge_keep_full_equip: 'คลังเต็ม — สวมใส่โดยตรง',
  forge_cost_label: 'ต้นทุน:',
  forge_result_label: 'ผลลัพธ์:',

  forge_recipe_weapon_lv5: 'สร้างอาวุธ Lv.5',
  forge_recipe_weapon_lv10: 'สร้างอาวุธ Lv.10',
  forge_recipe_weapon_lv15: 'สร้างอาวุธ Lv.15',
  forge_recipe_weapon_lv21: 'สร้างอาวุธ Lv.21 (รับประกัน)',
  forge_recipe_weapon_lv21_desc: 'รับอาวุธ Lv.21 ทันที ไม่ต้องตีบวก ไม่มีพลาด!',
  forge_recipe_scroll_basic: 'สร้างม้วนคุ้มครองพื้นฐาน',
  forge_recipe_scroll_mid: 'สร้างม้วนคุ้มครองกลาง',
  forge_recipe_scroll_hi: 'สร้างม้วนคุ้มครองสูง',
  forge_recipe_scroll_ultra: 'สร้างม้วนคุ้มครองสูงสุด',
  forge_recipe_upgrade_1: 'ผงเหล็ก → แก่นกลั่น',
  forge_recipe_upgrade_2: 'แก่นกลั่น → สาระลาวา',
  forge_recipe_upgrade_3: 'สาระลาวา → คริสตัลเหว',

  scroll_effect_basic: 'ป้องกันการทำลายเมื่อล้มเหลว (Lv.1-9)',
  scroll_effect_mid: 'ป้องกันการทำลายเมื่อล้มเหลว (Lv.10-19)',
  scroll_effect_hi: 'ป้องกันการทำลายเมื่อล้มเหลว (Lv.20-24)',
  scroll_effect_ultra: 'ป้องกันการทำลายเมื่อล้มเหลว (Lv.25-34)',
  scroll_buy_btn: 'ซื้อ',

  keep_card_equip: 'สวมใส่',
  keep_card_sell: 'ขาย',
  keep_slot_empty: 'ว่าง',

  sacrifice_btn: 'บูชาอาวุธ',
  sacrifice_panel_title: 'บูชาอาวุธ',
  sacrifice_panel_desc: 'บูชาอาวุธ Lv.{level} เพิ่มอัตราสำเร็จ +{tierPct}% ต่อชิ้น',
  sacrifice_empty: 'ไม่มีอาวุธ Lv.{level} ในคลัง',
  sacrifice_bonus_label: 'โบนัส: +{pct}%',
  sacrifice_cap_label: '({count}/{cap})',
  sacrifice_offer_btn: 'บูชา',
  sacrifice_ad_slots: 'ดูโฆษณา เพิ่มโอกาสสำเร็จ +{pct}%',
  sacrifice_ad_exhausted: 'ถึงขีดจำกัดโฆษณาแล้ว',
  sacrifice_ad_granted: 'เพิ่มบูชา +3 แล้ว!',
  sacrifice_added: 'รับบูชาแล้ว! +{tierPct}% โบนัส',
  sacrifice_cap_reached: 'ถึงขีดจำกัดบูชาแล้ว',
  sacrifice_reset: 'รีเซ็ตโบนัสบูชา',

  infinity_btn: 'อินฟินิตี้',
  infinity_active: 'ฟรี {sec}วิ',
  infinity_popup_title: 'โหมดอินฟินิตี้',
  infinity_popup_desc: 'ตีบวกไม่อั้น 10 วินาที ไม่ใช้ทอง!\nโอกาสสำเร็จเท่าเดิม — ล้มเหลวก็แตกได้!',
  infinity_popup_confirm: 'ดูโฆษณา',
  infinity_popup_close: 'ปิด',
  infinity_cooldown: 'พร้อมใช้ใน {sec}วิ',
  infinity_daily_exhausted: 'ถึงขีดจำกัดรายวันแล้ว',
  infinity_started: 'โหมดอินฟินิตี้ ON! ฟรี 10วิ',
  infinity_ended: 'โหมดอินฟินิตี้สิ้นสุด',

  buff_item_luck_charm: 'เครื่องรางนำโชค',
  buff_item_guarantee: 'ตั๋วรับประกัน',
  buff_item_destroy_guard: 'โล่ป้องกันการแตก',
  buff_item_use: 'ใช้',
  buff_item_active: 'ใช้งาน',
  buff_item_empty: '0',
  buff_luck_charm_activated: 'เครื่องรางนำโชคใช้งาน! +5% การอัปเกรดครั้งถัดไป',
  buff_guarantee_activated: 'ตั๋วรับประกันใช้งาน! อัปเกรดครั้งถัดไป 100%',
  buff_destroy_guard_activated: 'โล่ใช้งาน! ล้มเหลวครั้งถัดไปอาวุธไม่แตก',
  buff_luck_charm_consumed: 'เครื่องรางนำโชคถูกใช้แล้ว',
  buff_guarantee_consumed: 'ตั๋วรับประกันถูกใช้แล้ว',
  buff_destroy_guard_consumed: 'โล่ถูกใช้แล้ว — ป้องกันการแตก!',
  buff_item_already_active: 'ใช้งานอยู่แล้ว!',
  buff_item_none: 'ไม่มี {name}',
  buff_popup_count: 'มี: {count} ชิ้น',
  buff_popup_use_btn: 'ใช้ตอนนี้',
  buff_popup_no_stock: 'ไม่มีในมือ ไปสร้างที่เตาหลอม',
  buff_popup_luck_charm_effect: '+5% อัตราสำเร็จในการอัปเกรดครั้งถัดไป',
  buff_popup_guarantee_effect: 'การอัปเกรดครั้งถัดไปรับประกัน 100% สำเร็จ',
  buff_popup_destroy_guard_effect: 'หากอัปเกรดครั้งถัดไปล้มเหลว อาวุธจะไม่แตก (1 ครั้ง)',

  forge_recipe_item_luck_charm: 'สร้างเครื่องรางนำโชค',
  forge_recipe_item_luck_charm_desc: '+5% อัตราสำเร็จในการอัปเกรดครั้งถัดไป',
  forge_recipe_item_guarantee: 'สร้างตั๋วรับประกัน',
  forge_recipe_item_guarantee_desc: 'อัปเกรดครั้งถัดไป 100% สำเร็จ',
  forge_recipe_item_destroy_guard: 'สร้างโล่ป้องกันการแตก',
  forge_recipe_item_destroy_guard_desc: 'อาวุธจะไม่แตกในการล้มเหลวครั้งถัดไป',
  forge_tab_item: 'ไอเทม',
};

export default th;
